import React from "react";
import {RenameColumnsConfiguration} from "./configuration/rename-columns-configuration";
import {PreviewTab} from "../preview-tab/preview-tab";

export const RenameColumnsStepPanelTabs = {
    configuration: RenameColumnsConfiguration,
    preview: PreviewTab,
};
